class MockAPI {
  get = () => {};
  put = () => {};
  post = () => {};
  del = () => {};
}

export default new MockAPI();
